import Vue from 'vue'
import Vuex from 'vuex'
import busca from './modules/busca'
import abas from './modules/abas'
import ui from './modules/ui'
import tutorial from './modules/tutorial'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        busca,
        abas,
        ui,
        tutorial,
    }
})